import SuikaGame from "../lib/suikaGame";
import './index.module.scss'
const Test = () => <SuikaGame />
export default Test;